var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 10.6697C0.5 4.54013 5.30425 0 11.5 0C17.6957 0 22.5 4.54288 22.5 10.6725C22.5 16.802 17.6957 21.3422 11.5 21.3422C10.3863 21.3422 9.31925 21.1937 8.3155 20.9187C8.12025 20.8664 7.91125 20.8802 7.727 20.9627L5.5435 21.9251C5.41163 21.9833 5.26748 22.0082 5.12374 21.9976C4.97999 21.987 4.84105 21.9413 4.71911 21.8645C4.59718 21.7876 4.49599 21.682 4.42443 21.5569C4.35288 21.4318 4.31316 21.291 4.30875 21.1469L4.24825 19.189C4.24275 18.947 4.13275 18.7215 3.954 18.562C1.8145 16.648 0.5 13.8761 0.5 10.6697ZM8.12576 8.66501L4.89451 13.7909C4.58376 14.2831 5.18876 14.8358 5.65076 14.4839L9.12126 11.8494C9.23545 11.7627 9.37478 11.7155 9.51818 11.715C9.66157 11.7145 9.80122 11.7607 9.91601 11.8467L12.4873 13.7744C12.6696 13.9113 12.8784 14.009 13.1005 14.0612C13.3225 14.1134 13.5529 14.119 13.7772 14.0777C14.0015 14.0363 14.2148 13.9489 14.4036 13.821C14.5925 13.6931 14.7527 13.5274 14.8743 13.3344L18.1083 8.21128C18.4163 7.71904 17.8113 7.16355 17.3493 7.51554L13.8788 10.15C13.7646 10.2367 13.6252 10.2839 13.4818 10.2844C13.3385 10.2849 13.1988 10.2387 13.084 10.1527L10.5128 8.22503C10.3304 8.08806 10.1216 7.9904 9.89957 7.93819C9.67754 7.88599 9.4471 7.88039 9.2228 7.92173C8.9985 7.96308 8.7852 8.05047 8.59638 8.17841C8.40756 8.30634 8.24731 8.47203 8.12576 8.66501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.ce62dbbec2c403aeb759918e406d079b.svg";
export { ForwardRef as ReactComponent };